import {
  TIMESHEET_LOG_DAY_VIEW,
  calculateTotalHours,
  formatDateToDMY,
} from "@/lib/utils";
import { addDays, format, isBefore, isFuture, isWeekend } from "date-fns";

import { Badge } from "ui/components/badge";
import { Link } from "react-router-dom";
import React from "react";
import { cn } from "utils";

const TimesheetDayCell = ({ day }) => {
  const { events = [], isCurrentMonth, isToday } = day;
  const totalHours = events.reduce((sum, event) => sum + (event.hours || 0), 0);
  const uniqueJobs = new Set(events.map((event) => event.jobId));
  const totalJobs = uniqueJobs.size;
  const date = day.date;
  const dayNumber = format(date, "d");
  const isFutureDate = isFuture(date);

  const totalLoggedHours = calculateTotalHours(events, "hours");
  const totalApprovedHours = calculateTotalHours(events, "approved");
  const totalUnapprovedHours = calculateTotalHours(events, "unapproved");
  // Final mismatch check with floating point tolerance
  const hasHoursMismatch =
    Math.abs(totalLoggedHours - (totalApprovedHours + totalUnapprovedHours)) >=
    0.01;

  // Cell container styles
  const cellClasses = `relative h-24 bg-white p-3 hover:opacity-80 ${
    !isCurrentMonth || !hasHoursMismatch ? "!bg-gray-50 " : ""
  } ${totalJobs === 0 && isCurrentMonth ? "!bg-white" : ""}`;

  const renderDay = () => {
    return (
      <time
        dateTime={date}
        className={cn(
          "font-medium ",
          isToday
            ? "flex h-6 w-6 items-center justify-center rounded-full bg-black text-white"
            : undefined,
          isFutureDate ? "text-muted-foreground" : "!text-base-foreground"
        )}
      >
        {dayNumber}
      </time>
    );
  };

  // If there are no logs
  if (totalJobs === 0) {
    const isWeekendDay = isWeekend(date);
    const sevenDaysAgo = addDays(new Date(), -8);
    const isWithinSevenDays = !isBefore(date, sevenDaysAgo);

    return (
      <Link
        className={cellClasses}
        to={!isFutureDate && `/${TIMESHEET_LOG_DAY_VIEW}?date=${day.date}`}
      >
        <div className="flex flex-col h-full justify-between">
          {renderDay()}
          {!isWeekendDay && !isFutureDate && (
            <Badge
              className={cn(
                "text-xs text-red-400 bg-red-50 border-red-400 rounded-full",
                !isWithinSevenDays && "bg-zinc-50 border-zinc-400 text-zinc-400"
              )}
              variant="outline"
            >
              No Logs
            </Badge>
          )}
        </div>
      </Link>
    );
  }

  // If there are jobs and hours
  return (
    <Link
      to={!isFutureDate && `/${TIMESHEET_LOG_DAY_VIEW}?date=${day.date}`}
      className={cellClasses}
    >
      <div className="flex flex-col h-full justify-between">
        {renderDay()}

        <div className="mt-auto flex justify-between text-muted-foreground text-xs font-medium">
          <div>
            {totalJobs} {totalJobs === 1 ? "Job" : "Jobs"}
          </div>
          <div>{totalHours}h</div>
        </div>
      </div>
    </Link>
  );
};

export default TimesheetDayCell;
